import * as Yup from "yup";

export const validationSchema = Yup.object({
  email: Yup.string()
    .required("Not a valid email address")
    .email("Not a valid email address")
    .max(128, "Not a valid email address"),
});
